import { t as e } from "./chunk-chunk-uSt0Ebsl.js";
(/* @__PURE__ */ e(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? r(e) : typeof define == "function" && define.amd ? define(["exports"], r) : r((n = typeof globalThis < "u" ? globalThis : n || self).yett = {});
	})(e, (function(e) {
		var t = "javascript/blocked", n = {
			blacklist: window.YETT_BLACKLIST,
			whitelist: window.YETT_WHITELIST
		}, r = { blacklisted: [] }, i = function(e, r) {
			return e && (!r || r !== t) && (!n.blacklist || n.blacklist.some((function(t) {
				return t.test(e);
			}))) && (!n.whitelist || n.whitelist.every((function(t) {
				return !t.test(e);
			})));
		}, a = function(e) {
			var t = e.getAttribute("src");
			return n.blacklist && n.blacklist.every((function(e) {
				return !e.test(t);
			})) || n.whitelist && n.whitelist.some((function(e) {
				return e.test(t);
			}));
		}, o = new MutationObserver((function(e) {
			for (var n = 0; n < e.length; n++) for (var a = e[n].addedNodes, o = function(e) {
				var n = a[e];
				if (n.nodeType === 1 && n.tagName === "SCRIPT") {
					var o = n.src, s = n.type;
					i(o, s) && (r.blacklisted.push([n, n.type]), n.type = t, n.addEventListener("beforescriptexecute", (function e(r) {
						n.getAttribute("type") === t && r.preventDefault(), n.removeEventListener("beforescriptexecute", e);
					})), n.parentElement && n.parentElement.removeChild(n));
				}
			}, s = 0; s < a.length; s++) o(s);
		}));
		function s(e, t) {
			var n = Object.keys(e);
			if (Object.getOwnPropertySymbols) {
				var r = Object.getOwnPropertySymbols(e);
				t && (r = r.filter((function(t) {
					return Object.getOwnPropertyDescriptor(e, t).enumerable;
				}))), n.push.apply(n, r);
			}
			return n;
		}
		function c(e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t] == null ? {} : arguments[t];
				t % 2 ? s(Object(n), !0).forEach((function(t) {
					l(e, t, n[t]);
				})) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach((function(t) {
					Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
				}));
			}
			return e;
		}
		function l(e, t, n) {
			return t in e ? Object.defineProperty(e, t, {
				value: n,
				enumerable: !0,
				configurable: !0,
				writable: !0
			}) : e[t] = n, e;
		}
		function u(e, t) {
			return function(e) {
				if (Array.isArray(e)) return e;
			}(e) || function(e, t) {
				var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
				if (n != null) {
					var r, i, a = [], o = !0, s = !1;
					try {
						for (n = n.call(e); !(o = (r = n.next()).done) && (a.push(r.value), !t || a.length !== t); o = !0);
					} catch (e) {
						s = !0, i = e;
					} finally {
						try {
							o || n.return == null || n.return();
						} finally {
							if (s) throw i;
						}
					}
					return a;
				}
			}(e, t) || f(e, t) || function() {
				throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
			}();
		}
		function d(e) {
			return function(e) {
				if (Array.isArray(e)) return p(e);
			}(e) || function(e) {
				if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
			}(e) || f(e) || function() {
				throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
			}();
		}
		function f(e, t) {
			if (e) {
				if (typeof e == "string") return p(e, t);
				var n = Object.prototype.toString.call(e).slice(8, -1);
				return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? p(e, t) : void 0;
			}
		}
		function p(e, t) {
			(t == null || t > e.length) && (t = e.length);
			for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
			return r;
		}
		o.observe(document.documentElement, {
			childList: !0,
			subtree: !0
		});
		var m = document.createElement, h = {
			src: Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, "src"),
			type: Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, "type")
		};
		document.createElement = function() {
			var e = [...arguments];
			if (e[0].toLowerCase() !== "script") return m.bind(document).apply(void 0, e);
			var n = m.bind(document).apply(void 0, e);
			try {
				Object.defineProperties(n, {
					src: c(c({}, h.src), {}, { set: function(e) {
						i(e, n.type) && h.type.set.call(this, t), h.src.set.call(this, e);
					} }),
					type: c(c({}, h.type), {}, {
						get: function() {
							var e = h.type.get.call(this);
							return e === t || i(this.src, e) ? null : e;
						},
						set: function(e) {
							var r = i(n.src, n.type) ? t : e;
							h.type.set.call(this, r);
						}
					})
				}), n.setAttribute = function(e, t) {
					e === "type" || e === "src" ? n[e] = t : HTMLScriptElement.prototype.setAttribute.call(n, e, t);
				};
			} catch {
				console.warn("Yett: unable to prevent script execution for script src ", n.src, ".\n", "A likely cause would be because you are using a third-party browser extension that monkey patches the \"document.createElement\" function.");
			}
			return n;
		};
		var g = /* @__PURE__ */ RegExp("[|\\{}()[\\]^$+*?.]", "g");
		e.unblock = function() {
			var e = [...arguments];
			e.length < 1 ? (n.blacklist = [], n.whitelist = []) : (n.blacklist &&= n.blacklist.filter((function(t) {
				return e.every((function(e) {
					return typeof e == "string" ? !t.test(e) : e instanceof RegExp ? t.toString() !== e.toString() : void 0;
				}));
			})), n.whitelist &&= [].concat(d(n.whitelist), d(e.map((function(e) {
				if (typeof e == "string") {
					var t = ".*" + e.replace(g, "\\$&") + ".*";
					if (n.whitelist.every((function(e) {
						return e.toString() !== t.toString();
					}))) return new RegExp(t);
				} else if (e instanceof RegExp && n.whitelist.every((function(t) {
					return t.toString() !== e.toString();
				}))) return e;
				return null;
			})).filter(Boolean))));
			for (var i = document.querySelectorAll(`script[type="${t}"]`), s = 0; s < i.length; s++) {
				var c = i[s];
				a(c) && (r.blacklisted.push([c, "application/javascript"]), c.parentElement.removeChild(c));
			}
			var l = 0;
			d(r.blacklisted).forEach((function(e, t) {
				var n = u(e, 2), i = n[0], o = n[1];
				if (a(i)) {
					for (var s = document.createElement("script"), c = 0; c < i.attributes.length; c++) {
						var d = i.attributes[c];
						d.name !== "src" && d.name !== "type" && s.setAttribute(d.name, i.attributes[c].value);
					}
					s.setAttribute("src", i.src), s.setAttribute("type", o || "application/javascript"), document.head.appendChild(s), r.blacklisted.splice(t - l, 1), l++;
				}
			})), n.blacklist && n.blacklist.length < 1 && o.disconnect();
		}, Object.defineProperty(e, "__esModule", { value: !0 });
	}));
})))();
//#endregion
